const digest = '966ac35735dd4933bac578fc76f7235afc7e3adb945d4f83c17dce51e7651d2e';
const css = `._searchBar_73fez_1 [class*=formControl]{background-color:#000f3c}._searchBar_73fez_1 [class*=formControl] input{background-color:#000f3c;caret-color:#e0e0e0;color:#e0e0e0}._searchBar_73fez_1 input::placeholder{color:#e0e0e0}._searchBar_73fez_1 button{top:0!important}._searchBar_73fez_1 button div:hover{background-color:#000f3c!important}._searchBar_73fez_1 button svg{fill:#56a1e3!important;stroke:#56a1e3!important;stroke-width:2!important}._miniCallout_73fez_29{align-items:center;border:1px solid #3d4f82;border-radius:4px;display:flex;padding:.75rem 1rem}._miniCallout_73fez_29>span{color:var(--On-Surface-Text-Regular,#fbfbfb);margin-left:.5rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'searchBar': '_searchBar_73fez_1', 'miniCallout': '_miniCallout_73fez_29' };
export const searchBar = '_searchBar_73fez_1';
export const miniCallout = '_miniCallout_73fez_29';
export { css, digest };